import React, { useEffect, Suspense, memo, lazy } from 'react';
import ReactGA from 'react-ga4';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { datadogLogs } from '@datadog/browser-logs';
import { Router as AppRouter } from '~/app/Router';
import { Router as PublicRouter } from '~/public/Router';
import { ROUTE as ROUTE_APP } from '~/app/routes';
import { ThemeProvider } from '~/Theme/ThemeProvider';
import { IS_PRODUCTION, MODE, DATATDOG_BROWSER_LOGS_KEY } from '~/constants';
import { LogoLoading } from '~/elements';

ReactGA.initialize('G-SSHXC1SVP5');

export const Router = memo(() => {
  useEffect(() => {
    if (!IS_PRODUCTION) {
      return;
    }

    datadogLogs.init({
      clientToken: DATATDOG_BROWSER_LOGS_KEY,
      forwardErrorsToLogs: true,
      sampleRate: 100,
      version: import.meta.env.VITE_APP_VERSION || 'development',
      env: MODE === 'production' ? 'prod' : MODE,
      service: 'dashboard',
      beforeSend: (log) => {
        if (log.http && log.http.status_code !== 500) {
          return false;
        }
      },
    });
  }, []);

  return (
    <ThemeProvider>
      <Suspense fallback={<LogoLoading />}>
        <BrowserRouter>
          <Routes>
            <Route path={`${ROUTE_APP.ROOT}/*`} element={<AppRouter />} />
            <Route path="*" element={<PublicRouter />} />
          </Routes>
        </BrowserRouter>
      </Suspense>
    </ThemeProvider>
  );
});
